import type { ReactNode } from 'react';
import { Box, Button, Card, Stack } from '@mui/material';
import { AuroraBackground } from '@/components/AuroraBackground';
import { BrandLogo } from '@/components/brand/BrandLogo';
import { ColorModeToggle } from '@/components/ColorModeToggle';

/** Full-width page with the brand, outside the app's navigation. */
export function PageShell({
  children,
  onSignOut,
  plain,
}: {
  children: ReactNode;
  onSignOut: () => void;
  /** No card around the content (it brings its own). */
  plain?: boolean;
}) {
  return (
    <Box sx={{ minHeight: '100dvh' }}>
      <AuroraBackground />
      <Stack
        direction="row"
        spacing={1}
        sx={{ alignItems: 'center', maxWidth: 1100, mx: 'auto', px: { xs: 2, sm: 3 }, py: 1.5 }}
      >
        <BrandLogo size="medium" />
        <Box sx={{ flex: 1 }} />
        <ColorModeToggle />
        <Button color="inherit" onClick={onSignOut}>
          Sair
        </Button>
      </Stack>
      <Box component="main" sx={{ maxWidth: 1100, mx: 'auto', px: { xs: 2, sm: 3 }, pb: 8 }}>
        {plain ? children : <Card sx={{ p: { xs: 2.5, sm: 4 }, borderRadius: 6 }}>{children}</Card>}
      </Box>
    </Box>
  );
}
